"use strict";
// extra domain-model code is imported through this file
module.exports = {};
